import * as React from 'react';
import { Upload } from 'lucide-react';
import { DMDiv, DMInput, DMLabel, DMText } from '../Primitives';

type DMFileUploadDropzoneProps = {
  accept?: string;
  maxSizeLabel?: string;
  fileTypeLabel?: string;
  isUploading?: boolean;
  uploadLabel?: string;
  uploadingLabel?: string;
  className?: string;
  buttonClassName?: string;
  onFileSelect: (file: File) => void;
};

export const DMFileUploadDropzone = ({
  accept = 'image/png,image/jpeg,image/jpg',
  maxSizeLabel = 'Max 15mb',
  fileTypeLabel = 'png, jpg, jpeg',
  isUploading = false,
  uploadLabel = 'Upload Photo',
  uploadingLabel = 'Uploading...',
  className = '',
  buttonClassName,
  onFileSelect,
}: DMFileUploadDropzoneProps) => {
  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
    event.currentTarget.value = '';
  };

  return (
    <DMDiv
      className={`flex flex-col items-center justify-center rounded-[10px] border border-dashed border-gray-300 bg-white text-center ${className}`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <DMText className="text-[2.2vh] font-bold leading-tight text-gray-950">
        Choose a file or drag &amp; drop it here
      </DMText>
      <DMText className="mt-[1.2vh] text-[1.75vh] font-medium leading-tight text-gray-500">
        {fileTypeLabel} ({maxSizeLabel})
      </DMText>
      <DMLabel
        className={
          buttonClassName ||
          `mt-[1.8vh] flex h-[6vh] w-[17vw] items-center justify-center gap-[0.8vw] rounded-full border border-primary-main bg-white text-[1.85vh] font-semibold text-primary-main ${
            isUploading ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
          }`
        }
      >
        <Upload className="h-[2.1vh] w-[2.1vh]" strokeWidth={2} />
        <DMText as="span">{isUploading ? uploadingLabel : uploadLabel}</DMText>
        <DMInput
          type="file"
          accept={accept}
          className="hidden"
          disabled={isUploading}
          onChange={handleFileChange}
        />
      </DMLabel>
    </DMDiv>
  );
};
